export default __webpack_public_path__ + "static/media/Marco Ansaldo.e0c19d7d.jpg";